import { createSelector } from "@reduxjs/toolkit";
import { initialState, type AdminDashboardState } from "./slice";

const adminDashboardInitialState = (state: {
  adminDashboard?: AdminDashboardState;
}): AdminDashboardState => state.adminDashboard || initialState;

export const selectUsersList = createSelector(
  [adminDashboardInitialState],
  (state) => state.list,
);

export const selectAuthorize = createSelector(
  [adminDashboardInitialState],
  (state) => state.authorize,
);

export const selectDelete = createSelector(
  [adminDashboardInitialState],
  (state) => state.delete,
);

export const selectCreate = createSelector(
  [adminDashboardInitialState],
  (state) => state.create,
);
